import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpHeaders,
  HttpEvent
} from '@angular/common/http';
import { ASSETS_URL_REGEX } from './cache-assets.http-interceptor';
import { NonStaticInterceptor } from './nonstatic.http-interceptor';
import { Observable } from 'rxjs';

@Injectable()
export class CacheInterceptor extends NonStaticInterceptor implements HttpInterceptor {

  protected internalIntercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let reqHeaders = req.headers;
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Cache-Control
    reqHeaders = reqHeaders.set(
      'Cache-Control',
      'no-cache, no-store, must-revalidate, post-check=0, pre-check=0'
    );
    reqHeaders = reqHeaders.set('Pragma', 'no-cache');
    reqHeaders = reqHeaders.set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');

    let request = req.clone({
      headers: reqHeaders
    });
    return next.handle(request);
  }
}
